import {
    request
} from './http.js';
//评审端
class Service {
    //验证码
    static async getcode(data) {
        return request('Login/verify', data)
    }
	//登录
	static async loginjury(data) {
	    return request('Login/login_jury', data)
	}
	//底部信息
	static async siteoptions(data) {
	    return request('Login/site_options', data)
	}
	//赛事评审列表
	static async activitylist(data) {
	    return request('Reviewcenter/activity_list', data)
	}
	//赛事评审内页
	static async activitychoose(data) {
	    return request('Reviewcenter/activity_choose', data)
	}
	//完成评审
	static async accomplishjury(data) {
	    return request('Reviewcenter/accomplish_jury', data)
	}
	//作品详情
	static async workinfo(data) {
	    return request('Reviewcenter/work_info', data)
	}
	//作品打分
	static async workscore(data) {
	    return request('Reviewcenter/work_score', data)
	}
	//修改密码
	static async updatepwd(data) {
	    return request('Reviewcenter/update_pwd', data)
	}
	
	
	
	
}

export default {
    Service
}
